import Tween from "tween.ts";
import Animation from "../../../../../src/animation/Animation";
import Angle from "../../../../../src/entities/Angle/Angle";
import { Coord } from "../../../../../src/types/Interface";

export default class MoveAngles extends Animation {
  constructor(Angle: Angle, tCoord: Coord, onComp = () => { }) {
    super();
    new Tween.Tween(Angle)
      .to(tCoord, 1200)
      .easing(Tween.Easing.Linear.None)
      .onComplete(() => onComp())
      .start()
  }
}